var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { findIndex } from "lodash";
import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { createReducer } from "typesafe-actions";
import { appendAssignmentUnit, replaceAssignmentUnit } from "../epics/actions.js";
import { loadAssignmentUnitsEpicReducer } from "../epics/epicsV2.js";
const defaultReducerState = {
  assignmentUnits: getDefaultAsyncWrapperObj()
};
const actionsReducer = createReducer(defaultReducerState).handleAction(appendAssignmentUnit, (state, action) => __spreadProps(__spreadValues({}, state), {
  assignmentUnits: __spreadProps(__spreadValues({}, state.assignmentUnits), {
    data: [...state.assignmentUnits.data || [], action.payload]
  })
})).handleAction(replaceAssignmentUnit, (state, action) => {
  const items = [...state.assignmentUnits.data || []];
  const index = findIndex(items, (item) => item.id === action.payload.id);
  if (index < 0) {
    items.push(action.payload);
  } else {
    items[index] = action.payload;
  }
  return __spreadProps(__spreadValues({}, state), {
    assignmentUnits: __spreadProps(__spreadValues({}, state.assignmentUnits), {
      data: items
    })
  });
});
const reducer = (state = defaultReducerState, action) => {
  state = loadAssignmentUnitsEpicReducer.reduxChange(state, action);
  state = actionsReducer(state, action);
  return state;
};
export {
  actionsReducer,
  reducer as default,
  defaultReducerState,
  reducer
};
//# sourceMappingURL=ducks.js.map
